import { Route, Routes } from "react-router-dom";
import { Routes as SettingRoutes } from "./routes";
import { SettingRouterCmp } from "./types";
import SettingDetailPage from "../pages/tenant/SettingDetailPage/SettingDetailPage";
import { FleetSettingDetailPage } from "../pages/tenant/FleetSettingDetailPage";
import { DocumentDetailPage } from "../pages/tenant/DocumentDetailPage";
import { ListingDefaultsDetailPage } from "../pages/tenant/ListingDefaultsDetailPage";
import { OfficesSearchPage } from "../pages/tenant/OfficesSearchPage";

// Platformski ekrani (nadzorna ploča, tenanti, prijevodi, postavke aplikacije) preselili su se
// u `admin.autobiz` — ovdje ostaju samo postavke tenanta.
const SettingsRouter: SettingRouterCmp = () => {
  return (
    <>
      <Routes>
        <Route path={SettingDetailPage.route} element={<SettingDetailPage />} />
        <Route path={FleetSettingDetailPage.route} element={<FleetSettingDetailPage />} />
        <Route path={DocumentDetailPage.route} element={<DocumentDetailPage />} />
        <Route path={ListingDefaultsDetailPage.route} element={<ListingDefaultsDetailPage />} />
        <Route path={OfficesSearchPage.route} element={<OfficesSearchPage />} />
      </Routes>
    </>
  );
};

SettingsRouter.route = SettingRoutes.SettingRouter;

export default SettingsRouter;
